import React, {useState, useEffect} from 'react';
import {useForm, Controller} from 'react-hook-form';
import {default as ReactSelect, components} from "react-select";
import {Markup} from 'interweave';

function App(props) {
  const [fileName, setFileName] = useState('');
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState(true);
  const [isSending, setIsSending] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const {control, register, handleSubmit, formState: {errors}} = useForm();

  const Option = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };

  const handleFileChange = ({target}) => {
    setFileName(target.files[0]['name']);
  }

  const handleFormSubmit = (data) => {
    if (!isSending) {
      sendForm(data);
    }
  };

  const sendForm = (formData) => {
    setIsSending(true);
    let postBody = new FormData();

    postBody.append('company', formData['company']);
    postBody.append('email', formData['email']);
    postBody.append('phone', formData['phone']);
    postBody.append('assortment', JSON.stringify(formData['assortment'] || []));
    postBody.append('message', formData['message']);
    postBody.append('attachment', formData['attachment'][0]);

    const requestMetadata = {
      method: 'POST',
      body: postBody
    };

    fetch(zahradnicentra.api_url + '/form/contact/', requestMetadata)
      .then(res => res.json())
      .then((response) => {
        setSuccess(response.success);
        setMessage(response.message);
        setIsSending(false)
        setSubmitted(response.success);
      });
  };

  if (submitted && success) {
    return (
      <section className="form__wrapper">
        <div className="alert alert-success">
          {message}
        </div>
      </section>
    );
  }

  return (
    <section className="form__wrapper">
      {'' !== message &&
        <div className={`alert ${success ? 'alert-success' : 'alert-danger'}`}>
          {message}
        </div>
      }
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <div className="form__item">
          <label htmlFor="company">{zahradnicentra.form.labels.company}</label>
          <input type="text" id="company" required
                 {...register('company', {
                   required: zahradnicentra.form.errors.required
                 })} />
          {errors.company && <div className="form__error">{errors.company.message}</div>}
        </div>
        <div className="form__item">
          <label htmlFor="email">{zahradnicentra.form.labels.email}</label>
          <input type="email" id="email" required
                 placeholder="@"
                 {...register('email', {
                   required: zahradnicentra.form.errors.required,
                   pattern: {
                     value: /\S+@\S+\.\S+/,
                     message: zahradnicentra.form.errors.valid_email,
                   }
                 })} />
          {errors.email && <div className="form__error">{errors.email.message}</div>}
        </div>
        <div className="form__item form__item--file">
          <label htmlFor="attachment">{zahradnicentra.form.labels.attachment}</label>
          <input id="attachment" type="file" {...register("attachment")} onChange={handleFileChange}/>
          {'' === fileName && errors.attachment && <div className="form__error">{errors.attachment.message}</div>}
          {'' !== fileName &&
            <span className="form__item__info">{zahradnicentra.form.info.selected_file}: {fileName}</span>
          }
          <span className="form__mandatory">{zahradnicentra.form.info.mandatory}</span>
        </div>
        <div className="form__item">
          <label htmlFor="phone">{zahradnicentra.form.labels.phone}</label>
          <input type="tel" id="phone"
                 {...register('phone')} />
          {errors.phone && <div className="form__error">{errors.phone.message}</div>}
          <span className="form__mandatory">{zahradnicentra.form.info.mandatory}</span>
        </div>
        <div className="form__select">
          <label htmlFor="assortment">{zahradnicentra.form.labels.assortment}</label>
          <Controller
            name="assortment"
            control={control}
            rules={{
              validate: (value) =>
                value && value.length > 0 || zahradnicentra.form.errors.required
            }}
            defaultValue={[]}
            render={({field, fieldState}) => (
              <>
                <ReactSelect
                  placeholder=''
                  options={zahradnicentra.form.assortment}
                  className="react-select-container"
                  classNamePrefix="react-select"
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{
                    Option
                  }}
                  onChange={(val) => field.onChange(val)}
                />
                {fieldState.error && <div className="form__error">{fieldState.error.message}</div>}
              </>
            )}
          />
        </div>
        <div className="form__item">
          <label htmlFor="message">{zahradnicentra.form.labels.message}</label>
          <textarea id="message"
                    placeholder={zahradnicentra.form.info.message_placeholder}
                    {...register('message')}></textarea>
          {errors.message && <div className="form__error">{errors.message.message}</div>}
          <span className="form__mandatory">{zahradnicentra.form.info.mandatory}</span>
        </div>
        <div className="form__checkbox">
          <input type="checkbox" id="terms" required/>
          <label htmlFor="terms"><Markup content={zahradnicentra.form.labels.terms} noWrap={true}/></label>
        </div>
        <button type="submit" className=" button button--green button--full">
          {zahradnicentra.form.button.text}
        </button>
      </form>
    </section>
  );
}

export default App;
